import React from "react";
import { ContactUsText2 } from "./__ContactUs";
import NavbarSave from "../components/navbar-save";
import Footer from "../components/footer";

const title = "About Us";

const AboutUs = () => {
  return (
    <>
      <NavbarSave />
      <div className="bg-white w-100 h-100 overflow-y-auto" style={{ paddingTop: 156 }}>
        <div className="container">
          <div className="fs-1 fw-bold">{title}</div>
          <p className="mb-5">Last updated: {new Date().getFullYear()}</p>
          <div className="text-left">
            <AboutUsText />
          </div>
          <div className="py-5" />
          <div className="py-5" />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default AboutUs;
export { AboutUsText };

const AboutUsText = () => {
  return (
    <div>
      <p className="fs-5 mt-5">
        <strong>SAVE</strong> is an advanced, AI-driven cybersecurity platform
        built to simplify vulnerability management for individuals, startups,
        and large enterprises. Our goal is to deliver powerful security insights
        without the complexity—helping every organization stay protected in an
        evolving threat landscape.
      </p>

      <p className="fs-5">
        SAVE brings together web, network, and cloud scanning into a single,
        unified dashboard. With automated detection, deep analytics, and
        real-time monitoring, the platform provides the visibility you need to
        identify and eliminate risks before they become threats.
      </p>

      <div className="fs-3 fw-semibold mt-5">What SAVE Delivers:</div>

      <ul className="mt-3">
        <li className="fs-5">
          <strong>Comprehensive vulnerability scanning</strong> across web apps,
          networks, and multi-cloud environments (AWS, Azure, GCP)
        </li>

        <li className="fs-5">
          <strong>AI-powered analysis</strong> to highlight high-severity risks
          and misconfigurations
        </li>

        <li className="fs-5">
          <strong>Detailed reports</strong> ideal for audits, compliance, and
          technical assessments
        </li>

        <li className="fs-5">
          <strong>Centralized dashboards</strong> to monitor assets, threat
          posture, and scan usage in real time
        </li>

        <li className="fs-5">
          <strong>Secure authentication</strong> with 2FA, session management,
          and user-level access control
        </li>

        <li className="fs-5">
          <strong>Scalable plans</strong> that adapt to startups, growing
          businesses, and security-driven enterprises
        </li>
      </ul>

      <p className="fs-5 mt-4">
        Whether you're scanning a single website or managing a multi-cloud
        infrastructure, SAVE ensures that your digital ecosystem stays secure,
        compliant, and ready for the future.
      </p>
    </div>
  );
};
